/// <amd-module name="Reporting/Visuals/LayoutComponents/Widgets/LayoutActions" />
import { Action } from "VSS/Reflux/Action";
import { LayoutState } from "Widgets/LayoutState";

/**
 * A registry of layout related flux actions for action creators who use layouts, in a loosely coupled/testable fashion.
 */
export class LayoutActions {
    /**
     * Invoked to provide updated state data to the *store*.
     */
    public ProvideData: Action<LayoutState>;

    constructor() {
        this.ProvideData = new Action<LayoutState>();
    }
}
